export default [
  {
    path: '/organization',
    name: 'organization',
    component: () => import('@/views/admin/org/Organization'),
    children: [],
    meta: { title: '组织架构' }
  }
]
